<template>
  <div class="tree-catalog" :class="{ 'plain': plain }">
    <treeselect
      :value="value"
      :options="options"
      :multiple="multiple"
      :always-open="forceOpened"
      :searchable="true"
      :clearable="true"
      :maxHeight="NaN"
      :default-expand-level="1"
      :normalizer="normalize"
      :placeholder="placeholder"
      value-consists-of="LEAF_PRIORITY"
      @input="update"
      @select="select"
    />
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { mapGetters } from 'vuex';

export default {
  name: 'tree-catalog',

  components: {
    Treeselect,
  },

  props: {
    value: {
      type: null,
      required: true,
    },

    multiple: {
      type: Boolean,
      default: true,
    },

    alwaysOpen: {
      type: Boolean,
      default: true,
    },

    plain: {
      type: Boolean,
      default: true,
    },

    placeholder: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      forceOpened: false,
    };
  },

  computed: {
    ...mapGetters({
      options: 'accessoryCategories/treeCategories',
    }),
  },

  methods: {
    update(value) {
      this.$emit('input', value);
    },

    select(value) {
      this.$emit('select', value);
    },

    normalize(node) {
      return {
        ...node,
        label: node.title,
      };
    },
  },

  updated() {
    this.forceOpened = this.alwaysOpen; // исправляет багу в компоненте при отрисовке дерева
  },
};
</script>

<style lang="scss" scoped>
.tree-catalog {
  &.plain {
    &::v-deep .vue-treeselect {
      &__control {
        display: none;
      }

      &__menu {
        background: none;
        border: none;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        box-shadow: none;
      }
    }
  }
}
</style>

